import createFormModule from '../../utils/createFormModule'
import {
  SET_EMAIL,
  SET_WORKSPACE
} from './types'

const formModule = createFormModule({ resourcesPath: '/password_resets' })

export const state = {
  ...formModule.state,
  form: {
    email: '',
    workspace: ''
  }
}

export const mutations = {
  ...formModule.mutations,
  [SET_EMAIL] (state, value) {
    state.form.email = value
  },
  [SET_WORKSPACE] (state, value) {
    state.form.workspace = value
  }
}

export const actions = {
  ...formModule.actions,
  setEmail ({ commit }, value) {
    commit(SET_EMAIL, value)
  },
  setWorkspace ({ commit }, value) {
    commit(SET_WORKSPACE, value)
  },
  reset ({ commit }) {
    commit(SET_WORKSPACE, '')
    commit(SET_EMAIL, '')
  }
}

export const getters = {
  ...formModule.getters
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/passwordResetForm.js